module.exports = __webpack_public_path__ + "static/media/css_icon.2db97d69.svg";